/* Native Shopify product forms handle adding; JS only enhances filtering. */
(() => {
  const runtimeKey = '__oohMenuPageV2';
  if (window[runtimeKey]) {
    window[runtimeKey].init(document);
    return;
  }
  const instances = new Map();
  const rootsIn = (scope) => {
    const roots = [];
    if (scope.matches?.('[data-ooh-menu]')) roots.push(scope);
    roots.push(...scope.querySelectorAll('[data-ooh-menu]'));
    return roots;
  };
  function mount(root) {
    if (instances.has(root)) return;
    const pills = [...root.querySelectorAll('[data-ooh-filter]')];
    const cards = [...root.querySelectorAll('[data-ooh-card]')];
    if (!cards.length || !pills.length) return;
    const count = root.querySelector('[data-ooh-count]');
    const empty = root.querySelector('[data-ooh-empty]');
    const featured = root.querySelector('[data-ooh-featured]');
    const filtersWrap = root.querySelector('[data-ooh-filters-wrap]');
    const paginated = Boolean(root.querySelector('.ooh-menu-pagination'));
    const tagsByCard = new Map(cards.map(card => {
      let tags = [];
      try {
        const parsed = JSON.parse(card.dataset.oohTags || '[]');
        if (Array.isArray(parsed)) tags = parsed.map(tag => String(tag).trim().toLowerCase());
      } catch { /* Invalid tags never hide a product in the all view. */ }
      return [card, new Set(tags)];
    }));
    function applyFilter(filter) {
      let visible = 0;
      pills.forEach(pill => {
        const active = pill.dataset.oohFilter === filter;
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-pressed', String(active));
      });
      cards.forEach(card => {
        const match = filter === 'all' || tagsByCard.get(card).has(filter);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (featured) featured.hidden = filter !== 'all';
      if (empty) empty.hidden = visible > 0;
      if (count) count.textContent = `${visible} ${visible === 1 ? 'Sorte' : 'Sorten'}${paginated ? ' auf dieser Seite' : ''}`;
    }
    function onClick(event) {
      const pill = event.target.closest('[data-ooh-filter]');
      const reset = event.target.closest('[data-ooh-reset]');
      if (pill && root.contains(pill)) applyFilter(pill.dataset.oohFilter);
      else if (reset && root.contains(reset)) {
        applyFilter('all');
        pills[0]?.focus();
      }
    }
    root.addEventListener('click', onClick);
    instances.set(root, () => root.removeEventListener('click', onClick));
    applyFilter('all');
    if (filtersWrap) filtersWrap.hidden = false;
  }
  function init(scope = document) { rootsIn(scope).forEach(mount); }
  function unload(scope) {
    rootsIn(scope).forEach(root => {
      instances.get(root)?.();
      instances.delete(root);
    });
  }
  window[runtimeKey] = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();